import UniversityRoute from './routes/University';

export default (store) => ({
  path: 'university',
  indexRoute: UniversityRoute(store),
  childRoutes: [
  ]
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/University/index.js